import { captureException } from '../lib/sentry';
import { ErrorBoundary } from 'react-error-boundary';
import React from 'react';
const globalOnError = (error, info) => {
    captureException(error, { captureContext: { extra: info } });
};
const ErrorComponent = () => React.createElement(React.Fragment, null);
export const ReportErrorsToSentry = ({ children }) => (React.createElement(ErrorBoundary, { FallbackComponent: ErrorComponent, onError: globalOnError }, children));
